import { useEffect, useState } from 'react';

export const EXPORT_CSV_BUTTON_CONTAINER_ID = 'portal--export-csv--button-container';

export const useExportCsvButtonContainer = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    if (!container) {
      setContainer(document.getElementById(EXPORT_CSV_BUTTON_CONTAINER_ID));
    }
  }, [container]);

  return container;
};
